export default "/images/6a50a981be6d6727b27f3d3a394d7dba.avif";